import { createI18n } from 'vue-i18n'

import commonFi from './locales/fi/common.json'
import commonEn from './locales/en/common.json'
import commonSv from './locales/sv/common.json'
import layoutFi from './locales/fi/layout.json'
import layoutEn from './locales/en/layout.json'
import layoutSv from './locales/sv/layout.json'
import ticketsFi from './locales/fi/pages/tickets.json'
import ticketsEn from './locales/en/pages/tickets.json'
import ticketsSv from './locales/sv/pages/tickets.json'
import notificationsFi from './locales/fi/pages/notifications.json'
import notificationsEn from './locales/en/pages/notifications.json'
import notificationsSv from './locales/sv/pages/notifications.json'
import adminFi from './locales/fi/pages/admin.json'
import adminEn from './locales/en/pages/admin.json'
import adminSv from './locales/sv/pages/admin.json'

import { LOCALES } from '../config/locales.config'

const messages = {
  fi: { common: commonFi, layout: layoutFi, tickets: ticketsFi, notifications: notificationsFi, admin: adminFi },
  en: { common: commonEn, layout: layoutEn, tickets: ticketsEn, notifications: notificationsEn, admin: adminEn },
  sv: { common: commonSv, layout: layoutSv, tickets: ticketsSv, notifications: notificationsSv, admin: adminSv },
}

const getStoredLocale = () => {
  const stored = localStorage.getItem('locale')
  if (stored && LOCALES.includes(stored)) return stored
  return 'fi'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getStoredLocale(),
  fallbackLocale: 'fi',
  messages,
})

export const setLocale = (locale) => {
  if (LOCALES.includes(locale)) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
  }
}

export const t = i18n.global.t
export const te = i18n.global.te
export default i18n
